import {ConditionType} from "../../../../conditions/condition-types"
import DatetimeUtils from "../../../../../gd/utils/datetime-utils"
import {ConditionsLogicalOperator} from "../../../../conditions/collection"

export default function viewExpenses_convertOldSettingsToV2(settings: any) {
    // convert settings to version 2

    // convert settings into conditions
    const conditions = []
    if (settings?.users) {
        conditions.push({
            systemFieldId   : "expense.userId",
            type            : ConditionType.INCLUDES,
            value           : settings?.users
        })
    }

    if (settings?.projects) {
        conditions.push({
            systemFieldId   : "expense.projectId",
            type            : ConditionType.INCLUDES,
            value           : settings?.projects
        })
    }

    if (settings?.startDate) {
        conditions.push({
            systemFieldId   : "expense.expenseDate",
            type            : ConditionType.DATE_FIXED_AFTER,
            value           : DatetimeUtils.dateToMoment(settings?.startDate)?.format("YYYY-MM-DD")
        })
    }

    if (settings?.endDate) {
        conditions.push({
            systemFieldId   : "expense.expenseDate",
            type            : ConditionType.DATE_FIXED_BEFORE,
            value           : DatetimeUtils.dateToMoment(settings?.endDate)?.format("YYYY-MM-DD")
        })
    }

    const res: any = {
        preferences: _.omit(settings, ['users', 'projects', 'startDate', 'endDate'])
    }

    if (!_.isEmpty(conditions)) {
        res.conditions = {
            conditions      : conditions,
            logicalOperator : ConditionsLogicalOperator.AND
        }
    }

    return res
}